import { render, staticRenderFns } from "./allocationrules.vue?vue&type=template&id=2d4a0c66&"
import script from "./allocationrules.vue?vue&type=script&lang=ts&"
export * from "./allocationrules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "allocationrules.vue"
export default component.exports